// extracted by mini-css-extract-plugin
export default {"container":"style_container__JrBOJ","content":"style_content__phjxi","content_title":"style_content_title__fomZE","content_description":"style_content_description__KXK9R"};